const is_null = (o) => {
  if (o === undefined || o === null || o === "") return true;
  return Object.keys(o).length === 0;
};
export default is_null;
